/*
 * Auto-zarządzanie produktem "oplata-za-dostawe-serwis":
 * - Jeśli koszyk zawiera ≥1 produkt z tagiem "serwis" → wymuś obecność opłaty (qty=1)
 * - Jeśli żaden produkt nie ma tagu "serwis" → usuń opłatę z koszyka
 * Sprawdzanie odbywa się przy ładowaniu strony oraz po każdej zmianie koszyka (przechwycone fetch).
 */
(function () {
  const SURCHARGE_HANDLE = 'oplata-za-dostawe-serwis';
  const SERVICE_TAG = 'serwis';

  let surchargeVariantId = null;
  const tagCache = new Map();
  let isProcessing = false;
  let pendingCheck = false;

  async function getSurchargeVariantId() {
    if (surchargeVariantId) return surchargeVariantId;
    try {
      const r = await fetch(`/products/${SURCHARGE_HANDLE}.js`);
      if (!r.ok) return null;
      const data = await r.json();
      surchargeVariantId = data.variants && data.variants[0] && data.variants[0].id;
      return surchargeVariantId;
    } catch (e) {
      return null;
    }
  }

  async function getProductTags(handle) {
    if (tagCache.has(handle)) return tagCache.get(handle);
    try {
      const r = await fetch(`/products/${handle}.js`);
      if (!r.ok) {
        tagCache.set(handle, []);
        return [];
      }
      const data = await r.json();
      const tags = data.tags || [];
      tagCache.set(handle, tags);
      return tags;
    } catch (e) {
      tagCache.set(handle, []);
      return [];
    }
  }

  async function reloadCartUI() {
    // Wyemituj eventy, których motyw nasłuchuje, żeby odświeżyć drawer/sumę bez full reload
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
    // Fallback — jeśli nasłuch nie odświeży, wymuszony reload po krótkim czasie
    setTimeout(() => {
      // Pełny reload tylko jeśli jesteśmy na stronie /cart (tam Liquid musi się przerenderować)
      if (location.pathname === '/cart') location.reload();
    }, 300);
  }

  async function checkAndUpdate() {
    if (isProcessing) {
      pendingCheck = true;
      return;
    }
    isProcessing = true;
    try {
      const cartRes = await fetch('/cart.js', { credentials: 'same-origin' });
      if (!cartRes.ok) return;
      const cart = await cartRes.json();
      if (!cart.items || cart.items.length === 0) return;

      let hasService = false;
      let surchargeLine = null;

      for (const item of cart.items) {
        if (item.handle === SURCHARGE_HANDLE) {
          surchargeLine = item;
          continue;
        }
        const tags = await getProductTags(item.handle);
        if (tags.includes(SERVICE_TAG)) hasService = true;
      }

      if (hasService && !surchargeLine) {
        const variantId = await getSurchargeVariantId();
        if (!variantId) return;
        const r = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        if (r.ok) await reloadCartUI();
      } else if (!hasService && surchargeLine) {
        const r = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: surchargeLine.key, quantity: 0 })
        });
        if (r.ok) await reloadCartUI();
      } else if (hasService && surchargeLine && surchargeLine.quantity !== 1) {
        // Wymuś qty = 1
        const r = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: surchargeLine.key, quantity: 1 })
        });
        if (r.ok) await reloadCartUI();
      }
    } catch (e) {
      console.error('[serwis-fee] check failed', e);
    } finally {
      isProcessing = false;
      if (pendingCheck) {
        pendingCheck = false;
        setTimeout(checkAndUpdate, 50);
      }
    }
  }

  // Hook do fetch — gdy ktokolwiek zmieni koszyk, uruchom recheck
  const origFetch = window.fetch;
  window.fetch = function (...args) {
    const result = origFetch.apply(this, args);
    try {
      const url = (typeof args[0] === 'string') ? args[0] : (args[0] && args[0].url);
      if (url && /\/cart\/(add|change|update|clear)/.test(url)) {
        result.then(() => setTimeout(checkAndUpdate, 100)).catch(() => {});
      }
    } catch (e) {}
    return result;
  };

  // Hook do XHR (na wypadek motywów używających XMLHttpRequest)
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url, ...rest) {
    this.__url = url;
    return origOpen.call(this, method, url, ...rest);
  };
  const origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (...args) {
    this.addEventListener('load', () => {
      if (this.__url && /\/cart\/(add|change|update|clear)/.test(this.__url)) {
        setTimeout(checkAndUpdate, 100);
      }
    });
    return origSend.apply(this, args);
  };

  // Sprawdzenie startowe
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndUpdate);
  } else {
    checkAndUpdate();
  }
})();